import React from 'react';
import { Button } from '../../components/ui/button';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { robotoRegularBase64 } from './roboto';

const ECCNomineeListPDF = ({ nominees, onClose }) => {
  console.log("nomenees", nominees)
  const generatePDF = () => {
    const doc = new jsPDF();


    doc.setLanguage('pl');

    // Dodanie czcionki Roboto do jsPDF
    doc.addFileToVFS('Roboto-Regular.ttf', robotoRegularBase64);
    doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal');

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    
    // Margins and available width
    const marginLeft = 20;
    const marginRight = 20;
    const availableWidth = pageWidth - marginLeft - marginRight;

    // Current date and time
    const now = new Date();
    const formattedDate = now.toLocaleString();

    // Document header styling
    doc.setFont('Roboto', 'normal');
    doc.setFontSize(14);
    doc.text(
      `Official nomination document for the day: ${formattedDate}`,
      marginLeft,
      20
    );

    // Main title
    doc.setFontSize(18);
    doc.text("Nominee List", marginLeft, 30);
    

    // Prepare table data with proper formatting
    const data = nominees.map(nominee => {
      const name = nominee.user_data
        ? nominee.user_data.first_name && nominee.user_data.last_name
          ? `${nominee.user_data.first_name} ${nominee.user_data.last_name}`
          : nominee.user_data.user_name || "N/A"
        : "N/A";

      const company = nominee.company_data?.name || 
                     nominee.company_to_data?.name || 
                     "N/A";

      const workscopeText = Array.isArray(nominee.work_scope_data) && 
                           nominee.work_scope_data.length > 0
        ? nominee.work_scope_data.map(ws => ws.name).join("\n")
        : "N/A";

      const sepEText = nominee.sepEExpiryDate ? `${nominee.sepEExpiryDate}` : "No";
      const sepDText = nominee.sepDExpiryDate ? `${nominee.sepDExpiryDate}` : "No";

      return [name, company, workscopeText, sepEText, sepDText];
    });

    // Enhanced table configuration
    autoTable(doc, {
      startY: 40,
      margin: { left: marginLeft, right: marginRight },
      head: [['Name', 'Company', 'Workscope', 'SEP E', 'SEP D']],
      body: data,
      styles: {
        font: 'Roboto',
        fontSize: 10,
        cellPadding: 3,
        lineColor: [200, 200, 200],
        lineWidth: 0.1,
      },
      headStyles: {
        fillColor: [240, 240, 240],
        textColor: [50, 50, 50],
        fontStyle: 'bold',
        halign: 'center',
        fontSize: 12,
      },
      columnStyles: {
        0: { cellWidth: availableWidth * 0.15, halign: 'left' },
        1: { cellWidth: availableWidth * 0.15, halign: 'left' },
        2: { cellWidth: availableWidth * 0.4, halign: 'left' },
        3: { cellWidth: availableWidth * 0.15, halign: 'center' }, // SEP E
        4: { cellWidth: availableWidth * 0.15, halign: 'center' }, // SEP D
      },
      alternateRowStyles: {
        fillColor: [248, 248, 248],
      },
      didParseCell: (data) => {
        if (data.section === 'body' && data.column.index === 2) {
          data.cell.styles.cellPadding = { top: 5, right: 5, bottom: 5, left: 5 };
        }
      },
      willDrawCell: (data) => {
        if (data.section === 'body' && data.column.index === 2) {
          data.cell.styles.minCellHeight = 20;
        }
      },
    });

    // Footer with page numbers
    const totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(10);
      doc.setFont('Roboto', 'normal');
      doc.text(
        `Document generated from the Winduno system - Page ${i} of ${totalPages}`,
        pageWidth / 2,
        pageHeight - 10,
        { align: 'center' }
      );
    }

    doc.save("NomineeList.pdf");
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 backdrop-blur-sm z-50">
      <div className="bg-white rounded-lg shadow-xl w-3/4 max-w-6xl p-6">
        <h2 className="text-2xl font-semibold mb-6">Export List to PDF</h2>
        <div className="bg-gray-50 rounded-lg p-6 mb-6 max-h-[60vh] overflow-auto">
          <table className="w-full">
            <thead className="bg-gray-100">
              <tr>
                <th className="py-3 px-4 text-left font-semibold w-1/8">Name</th>
                <th className="py-3 px-4 text-left font-semibold w-1/8">Company</th>
                <th className="py-3 px-4 text-left font-semibold w-1/2">Workscope</th>
                <th className="py-3 px-4 text-left font-semibold w-1/8">SEP E</th>
                <th className="py-3 px-4 text-left font-semibold w-1/8">SEP D</th>
              </tr>
            </thead>
            <tbody>
              {nominees.map((nominee, index) => {
                const name = nominee.user_data
                  ? nominee.user_data.first_name && nominee.user_data.last_name
                    ? `${nominee.user_data.first_name} ${nominee.user_data.last_name}`
                    : nominee.user_data.user_name || "N/A"
                  : "N/A";

                const company = nominee.company_data?.name || "N/A";

                const workscopeText = Array.isArray(nominee.work_scope_data) && 
                                    nominee.work_scope_data.length > 0
                  ? nominee.work_scope_data.map(ws => ws.name).join(", ")
                  : "N/A";

                const sepe = nominee.sepEExpiryDate || "No";
                const sepd = nominee.sepDExpiryDate || "No";

                return (
                  <tr 
                    key={index}
                    className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}
                  >
                    <td className="py-3 px-4 border-t">{name}</td>
                    <td className="py-3 px-4 border-t">{company}</td>
                    <td className="py-3 px-4 border-t">{workscopeText}</td>
                    <td className="py-3 px-4 border-t">{sepe}</td>
                    <td className="py-3 px-4 border-t">{sepd}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="flex justify-end space-x-4">
          <Button              
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 text-[#002D43] rounded-full hover:bg-gray-50"
          >
            Cancel
          </Button>
          <Button 
            onClick={generatePDF}
            className="px-4 py-2 border border-gray-300 text-[#002D43] rounded-full hover:bg-gray-50"
          >
            Download PDF
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ECCNomineeListPDF;